import { lightTheme } from '@/customTheme'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { KIND } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import Icons from '@/scenes/Editor/components/Icons'
import { useEffect, useRef } from 'react'

interface WhatsNewSingleColumnProps {
  data: any[]
  onClose: () => void
}

function WhatsNewSingleColumn({ data, onClose }: WhatsNewSingleColumnProps) {
  const { t } = useTranslation()
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    return () => {
      video?.pause()
    }
  }, [])

  return (
    <div
      style={{
        width: '433px',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'absolute',
      }}
      id="modal-what-new"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px 24px 16px 24px',
        }}
      >
        <span
          style={{
            ...lightTheme.typography.Header20bold,
            color: lightTheme.colors.blackGray,
            letterSpacing: '-0.34px',
          }}
        >
          {t(data[0]?.text)}
        </span>
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            flexShrink: 0,
          }}
          onClick={onClose}
        >
          <Icons.Close size={24} fill={lightTheme.colors.blackGray} />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', padding: '0 24px' }}>
        <div
          style={{
            width: '385px',
            height: '385px',
            borderRadius: '12px',
            overflow: 'hidden',
            background: lightTheme.colors.grayScale50,
            flexShrink: 0,
          }}
        >
          <video
            ref={videoRef}
            width="100%"
            height="100%"
            style={{ objectFit: 'cover', display: 'block' }}
            loop
            autoPlay
            muted
            playsInline
            src={data[0].video}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '24px' }}>
        <ButtonCustom
          type={SizeButton.STANDARD}
          kind={KIND.primary}
          style={{
            ...lightTheme.typography.Small14Semibold,
            color: lightTheme.colors.white,
            minWidth: '120px',
            width: 'fit-content',
          }}
          onClick={onClose}
        >
          {t('Try it now')}
        </ButtonCustom>
      </div>
    </div>
  )
}

export default WhatsNewSingleColumn
